import React from "react";
import {
  CloseButtonStyled,
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  InfoIconStyled,
  InterviewWelcomeButton,
} from "./style";
import { Dialog, Typography, Box } from "@mui/material";
import { Close as CloseIcon, Info as InfoIcon } from "@mui/icons-material";

const MeetingTimeDilogue = ({
  open,
  onClose,
  message,
  startInterview = () => {},
  showStartButton = false,
  isStartButtonDisabled,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      className="back_drop_box"
      sx={{
        "&.back_drop_box .css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop": {
          backdropFilter: "blur(40px)", // 4px
          background: "rgba(0, 0, 0, 0.4)",
        },
      }}
    >
      <DialogTitleStyled>
        <Box display="flex" alignItems="center">
          <InfoIconStyled />
          <Typography variant="h6" component="span" ml={1}>
            Interview Information
          </Typography>
        </Box>
      </DialogTitleStyled>
      <DialogContentStyled>
        <Typography
          variant="body1"
          color="textSecondary"
          marginTop={3}
          marginBottom={2}
        >
          {message}
        </Typography>
        {showStartButton && (
          <InterviewWelcomeButton
            disabled={isStartButtonDisabled}
            variant="contained"
            onClick={startInterview}
            fullWidth
          >
            Start Interview
          </InterviewWelcomeButton>
        )}
      </DialogContentStyled>
    </Dialog>
  );
};

export default MeetingTimeDilogue;
